import { Helmet } from 'react-helmet-async';

interface HowToStep {
  name: string;
  text: string;
  url?: string;
}

interface HowToSchemaProps {
  name: string;
  description: string;
  steps: HowToStep[];
  language?: string;
}

const HowToSchema = ({ name, description, steps, language = "sr-RS" }: HowToSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "inLanguage": language,
    "name": name,
    "description": description,
    "mainEntityOfPage": language === "en" ? "https://physiowrld.rs/en" : "https://physiowrld.rs/",
    "areaServed": {
      "@type": "AdministrativeArea",
      "name": language === "en" ? "New Belgrade" : "Novi Beograd"
    },
    "provider": {
      "@type": "MedicalClinic",
      "name": "PHYSIOWRLD",
      "url": language === "en" ? "https://physiowrld.rs/en" : "https://physiowrld.rs/",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Omladinskih brigada 96E/4",
        "addressLocality": language === "en" ? "Belgrade" : "Beograd",
        "addressRegion": "RS",
        "postalCode": "11070",
        "addressCountry": "RS"
      },
      "telephone": "+381605037477",
      "medicalSpecialty": ["Physiotherapy", "Rehabilitation"]
    },
    "step": steps.map(step => ({
      "@type": "HowToStep",
      "name": step.name,
      "text": step.text,
      ...(step.url && { "url": step.url })
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default HowToSchema;
